import React, { useState, useEffect } from "react";
import { ParkingDataContext } from "./context";

import { getParkingData, getParkingDetails } from "../services/services";

const ParkingProvider = ({ children }) => {
  const [parkingData, setParkingData] = useState(null);
  const [loadingParking, setLoadingParking] = useState(true);
  const [parkingDetailsData, setParkingDetailsData] = useState(null);
  const [loadingParkingDetails, setLoadingParkingDetails] = useState(true);
  const [errorParking, setErrorParking] = useState(null);
  const [errorParkingDetails, setErrorParkingDetails] = useState(null);

  useEffect(() => {
    const fetchParking = async () => {
      const parking = await getParkingData({ lang: "el" })
        .then((response) => {
          if (response.length > 0) {
            setLoadingParking(false);
            return response;
          } else {
            setLoadingParking(false);
            return [];
          }
        })
        .catch((error) => {
          setLoadingParking(false);
          setErrorParking(error);
        });
      const parkingDetails = await getParkingDetails({ lang: "el" })
        .then((response) => {
          if (response.length > 0) {
            setLoadingParkingDetails(false);
            return response;
          } else {
            setLoadingParkingDetails(false);
            return [];
          }
        })
        .catch((error) => {
          setLoadingParkingDetails(false);
          setErrorParkingDetails(error);
        });
      setParkingData(parking);
      setParkingDetailsData(parkingDetails);
    };

    fetchParking();
  }, []);

  return (
    <ParkingDataContext.Provider
      value={{
        parkingData,
        parkingDetailsData,
        setParkingData,
        setParkingDetailsData,
        loadingParking,
        loadingParkingDetails,
        errorParking,
        errorParkingDetails,
      }}
    >
      {children}
    </ParkingDataContext.Provider>
  );
};

export default ParkingProvider;
